import { ssrCommunitySearch } from '@/server/ssr-community-search'
import { createFileRoute } from '@tanstack/react-router'
import { AgentCommunity } from '@/components/ledger/AgentCommunity'
import { ssrCommunity } from '@/server/ssr-community'
import { localizedPageHead } from '@/lib/seo-head'
import { communitySearch } from '@/lib/community-search'
import { communityView } from '@/lib/community-view'
import { ssrPublicWorkList } from '@/server/ssr-work'
export const Route=createFileRoute('/{-$locale}/community')({
 validateSearch:communitySearch,
 loaderDeps:({search})=>search,
 loader:async({deps})=>{
  // SSR needs indexable initial content. In the browser the mounted readers
  // already fetch the active view; a second loader fetch duplicates that read.
  if(typeof window!=='undefined')return {discussion:null,work:null,search:null}
  const view=communityView(deps)
  return {
   search:view==='search'?await ssrCommunitySearch(deps.q,deps.tag):null,
   discussion:view==='discussions'?await ssrCommunity(undefined,deps.tag,deps):null,
   work:view==='work'?await ssrPublicWorkList():null,
  }
 },
 head:({params,match})=>{const head={...localizedPageHead('community',params.locale),links:[{rel:'alternate',type:'application/rss+xml',title:'Horizon Tech Community',href:'/community-feed.xml'}]};return Object.values(match.search).some(Boolean)?{...head,meta:[...head.meta,{name:'robots',content:'noindex,follow'}]}:head},
 component:()=> <AgentCommunity initialSearch={Route.useLoaderData().search} initialTag={Route.useSearch().tag} initialFilters={Route.useSearch()} initialDiscussion={Route.useLoaderData().discussion??undefined} initialWork={Route.useLoaderData().work}/>,
})
